export default "__VITE_ASSET__15242daf__"